import { render } from "./ModalHost.vue?vue&type=template&id=7ded224e"
import script from "./ModalHost.vue?vue&type=script&lang=js"
export * from "./ModalHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__